import moment from 'moment'; // Import moment

export const customFormat = (number: number, handleCero?: boolean) => {
    if (handleCero && number === 0) return number.toFixed(2);

    let format = { letter: '', denominator: 1 };
    if (number >= 1000000000000) format = { letter: 'T', denominator: 1000000000000 };
    else if (number >= 1000000000) format = { letter: 'B', denominator: 1000000000 };
    else if (number >= 1000000) format = { letter: 'M', denominator: 1000000 };
    else if (number >= 1000) format = { letter: 'k', denominator: 1000 };
    else if (number <= -1000000000) format = { letter: 'B', denominator: 1000000000 };
    else if (number <= -1000000) format = { letter: 'M', denominator: 1000000 };
    else if (number <= -1000) format = { letter: 'k', denominator: 1000 };
    let { letter, denominator } = format
    return `${+(number / denominator).toFixed(number / denominator < 100 ? 1 : 0)}${letter}`
}

export const dateDMY = (inDate: any) => {
    let dt = new Date(inDate);
    if (dt.getFullYear() === 1) { return "-"; }
    return (dt.getMonth() + 1) + "/" + dt.getDate() + "/" + dt.getFullYear()
}

export const formatWithCommas = (number: number) => number && new Intl.NumberFormat().format(number);

export const convertToAmPm = (hour: number): string => {
    // Validate that the input is within the expected range
    if (hour < 0 || hour > 24) {
        throw new Error('Hour must be 0 through 23.');
    }

    const time = moment().hours(hour % 24).minutes(0);

    return time.format('hh:mm A');
}

export const yAxisCustomFormat = (number: number, handleCero?: boolean) => {
    if (handleCero && number === 0) return number.toFixed(5);

    let format = { letter: '', denominator: 1 };
    if (number >= 1e12) format = { letter: 'T', denominator: 1e12 };
    else if (number >= 1e9) format = { letter: 'B', denominator: 1e9 };
    else if (number >= 1e6) format = { letter: 'M', denominator: 1e6 };
    else if (number >= 1e3) format = { letter: 'k', denominator: 1e3 };
    else if (number <= -1e9) format = { letter: 'B', denominator: 1e9 };
    else if (number <= -1e6) format = { letter: 'M', denominator: 1e6 };
    else if (number <= -1e3) format = { letter: 'k', denominator: 1e3 };

    const value = number / format.denominator;

    return `${+value.toFixed(value < 1 ? 5 : value < 100 ? 2 : 0)}${format.letter}`;
};